export default __webpack_public_path__ + "static/wand-education-_medium_1-b0ff93e6cbf129185f29a173c55e5f8c.webp";